import { Stack } from '@mui/material'
import { RegionChip } from '@/components/inputs/common/RegionChip'
import { Scrollbar } from '@/components/Scrollbar'

import { GeoRegion, RegionFilterCode, regions } from './GeoBlockingTemplateForm.constants'

type SelectedRegionsChipsProps = {
  selectedRegions: GeoRegion[]
  regionFilter: RegionFilterCode
  onRemoveRegion: (region: GeoRegion) => void
  height?: number
}

export const SelectedRegionsChips = ({
  selectedRegions,
  regionFilter,
  onRemoveRegion,
  height = 355
}: SelectedRegionsChipsProps) => {
  const sortedRegions = [...selectedRegions].sort((a, b) => {
    if (regionFilter !== 'All') {
      const selectedContinent = regions.find((c) => c.name === regionFilter)

      let aMatchesFilter = false
      let bMatchesFilter = false

      if (selectedContinent) {
        if (selectedContinent.name === 'US State' || selectedContinent.name === 'CA Province') {
          aMatchesFilter = a.continent === selectedContinent.name
          bMatchesFilter = b.continent === selectedContinent.name
        } else {
          aMatchesFilter = a.continent === selectedContinent.code
          bMatchesFilter = b.continent === selectedContinent.code
        }
      }

      if (aMatchesFilter && !bMatchesFilter) return -1
      if (!aMatchesFilter && bMatchesFilter) return 1
    }

    if (a.sortOrder !== b.sortOrder) {
      return a.sortOrder - b.sortOrder
    }

    return a.displayLabel.localeCompare(b.displayLabel)
  })

  return (
    <Scrollbar style={{ height }}>
      <Stack direction="row" gap={0.5} flexWrap="wrap" pb={2}>
        {sortedRegions.map((region) => {
          const selectedContinent = regions.find((c) => c.name === regionFilter)

          let matchesFilter = regionFilter === 'All'

          if (!matchesFilter && selectedContinent) {
            if (selectedContinent.name === 'US State' || selectedContinent.name === 'CA Province') {
              matchesFilter = region.continent === selectedContinent.name
            } else {
              matchesFilter = region.continent === selectedContinent.code
            }
          }
          return (
            <RegionChip
              withFlag
              region={region}
              ChipSx={{
                opacity: matchesFilter ? 1 : 0.5,
                '& .MuiChip-deleteIcon': {
                  opacity: 1
                }
              }}
              onDelete={() => onRemoveRegion(region)}
            />
          )
        })}
      </Stack>
    </Scrollbar>
  )
}
